import * as React from 'react'

import { inject, observer } from 'mobx-react'

import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'
import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import Localization from '~/client/src/shared/localization/LocalizationManager'
import { DELETE_REMOTE_TILESET } from '~/client/src/shared/stores/EventStore/eventConstants'

import MapViewSetUpStore from '../../../MapViewSetUp.store'

// localization: translated

interface IProps {
  store: MapViewSetUpStore
  isRemote?: boolean
  state?: DesktopInitialState
}

@inject('state')
@observer
export default class DeleteTilesetConfirmDialog extends React.Component<IProps> {
  public render() {
    const { deletable, title, onHide, onApply, isDeleting } = this.target

    if (!deletable) {
      return null
    }

    return (
      <ConfirmDialog
        isOpen
        title={title}
        onCancelClicked={onHide}
        onDoneClicked={onApply}
        doneTitle={Localization.translator.delete}
        loading={isDeleting}
        useRedConfirmationButton
      >
        <div className="tw:truncate tw:text-body-md tw:font-bold tw:text-foreground">
          {deletable.name}
        </div>
      </ConfirmDialog>
    )
  }

  private get target() {
    const { isRemote, store, state } = this.props

    if (isRemote) {
      const {
        deletableRemoteTileset,
        hideRemoteTilesetDeleteConfirmDialog,
        applyRemoteTilesetDeleteConfirmDialog,
      } = store.remoteTilesetsSetupStore

      return {
        deletable: deletableRemoteTileset,
        title: Localization.translator.areYouSureDeleteRemoteTileset,
        onHide: hideRemoteTilesetDeleteConfirmDialog,
        onApply: applyRemoteTilesetDeleteConfirmDialog,
        isDeleting: state.loading.get(DELETE_REMOTE_TILESET),
      }
    }

    const {
      deletableTileset,
      hideTilesetDeleteConfirmDialog,
      applyTilesetDeleteConfirmDialog,
      isDeletingTileset,
    } = store.tilesetsSetupStore

    return {
      deletable: deletableTileset,
      title: Localization.translator.areYouSureDeleteTileset,
      onHide: hideTilesetDeleteConfirmDialog,
      onApply: applyTilesetDeleteConfirmDialog,
      isDeleting: isDeletingTileset,
    }
  }
}
